var _toConsumableArray = require("/Users/dandregregory/workspace/EEMERGPLATFORM/SP_SIGNUP_APP/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Users/dandregregory/workspace/EEMERGPLATFORM/SP_SIGNUP_APP/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/dandregregory/workspace/EEMERGPLATFORM/SP_SIGNUP_APP/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _require = require('./util'),
    traverse = _require.traverse,
    getValFromPath = _require.getValFromPath;

var Validator =
/*#__PURE__*/
function () {
  "use strict";

  function Validator(o) {
    _classCallCheck(this, Validator);

    this.rules = o;
  }

  _createClass(Validator, [{
    key: "test",
    value: function test(o) {
      var ret = true;
      traverse(this.rules, function (rule, path) {
        if (rule.test(getValFromPath(path, o), o) === false) {
          ret = false;
        }
      });
      return ret;
    }
  }, {
    key: "testAll",
    value: function testAll(arr) {
      for (var i = 0; i < arr.length; i += 1) {
        if (this.test(arr[i]) === false) {
          return i;
        }
      }

      return -1;
    }
  }, {
    key: "getErrors",
    value: function getErrors(o) {
      var errors = [];
      traverse(this.rules, function (rule, path) {
        if (rule.test(getValFromPath(path, o), o, path) === false) {
          errors = _toConsumableArray(errors).concat(_toConsumableArray(rule.errorCollector.get()));
        }
      });
      return errors;
    }
  }]);

  return Validator;
}();

module.exports = Validator;